import type { AssistantContextValue } from '../model/types'

import { use } from 'react'

import { AssistantContext } from '../model/AssistantContext'

export function useAssistantConversation() {
	return use<AssistantContextValue>(AssistantContext)
}
